var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __reExport = (target, module, copyDefault, desc) => {
  if (module && typeof module === "object" || typeof module === "function") {
    for (let key of __getOwnPropNames(module))
      if (!__hasOwnProp.call(target, key) && (copyDefault || key !== "default"))
        __defProp(target, key, { get: () => module[key], enumerable: !(desc = __getOwnPropDesc(module, key)) || desc.enumerable });
  }
  return target;
};
var __toESM = (module, isNodeMode) => {
  return __reExport(__markAsModule(__defProp(module != null ? __create(__getProtoOf(module)) : {}, "default", !isNodeMode && module && module.__esModule ? { get: () => module.default, enumerable: true } : { value: module, enumerable: true })), module);
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// src/themes/theme.styles.ts
import { css } from "lit";
var theme_styles_default = css`
	:root,
	:host,
	.yotpo-theme {
		/*
* Color Primitives
*/

		/* Blue */
		--yotpo-color-blue-100: #272850;
		--yotpo-color-blue-90: #0a2e87;
		--yotpo-color-blue-80: #0032ac;
		--yotpo-color-blue-70: #0042e4;
		--yotpo-color-blue-60: #4071eb;
		--yotpo-color-blue-50: #618aee;
		--yotpo-color-blue-40: #99b3f4;
		--yotpo-color-blue-30: #b3c6f7;
		--yotpo-color-blue-20: #ccd9fa;
		--yotpo-color-blue-10: #e6ecfc;

		/* Green */
		--yotpo-color-green-100: #2c6b3a;
		--yotpo-color-green-90: #378549;
		--yotpo-color-green-80: #3f9752;
		--yotpo-color-green-70: #4ab261;
		--yotpo-color-green-60: #80c990;
		--yotpo-color-green-50: #92d1a0;
		--yotpo-color-green-40: #b7e0c0;
		--yotpo-color-green-30: #c9e8d0;
		--yotpo-color-green-20: #dbf0df;
		--yotpo-color-green-10: #e4f3e7;

		/* Red */
		--yotpo-color-red-100: #731313;
		--yotpo-color-red-90: #901818;
		--yotpo-color-red-80: #a31b1b;
		--yotpo-color-red-70: #c02020;
		--yotpo-color-red-60: #d36363;
		--yotpo-color-red-50: #d97979;
		--yotpo-color-red-40: #e6a6a6;
		--yotpo-color-red-30: #ecbcbc;
		--yotpo-color-red-20: #f2d2d2;
		--yotpo-color-red-10: #f6dddd;

		/* Yellow */
		--yotpo-color-yellow-100: #866806;
		--yotpo-color-yellow-90: #b68c00;
		--yotpo-color-yellow-80: #cf9f00;
		--yotpo-color-yellow-70: #f3bb00;
		--yotpo-color-yellow-60: #f7cf4c;
		--yotpo-color-yellow-50: #f8d666;
		--yotpo-color-yellow-40: #fae499;
		--yotpo-color-yellow-30: #fbebb2;
		--yotpo-color-yellow-20: #fdf1cc;
		--yotpo-color-yellow-10: #fdf5d9;

		/* Purple */
		--yotpo-color-purple-100: #5344a6;
		--yotpo-color-purple-90: #6154ad;
		--yotpo-color-purple-80: #6f5fc4;
		--yotpo-color-purple-70: #8270e7;
		--yotpo-color-purple-60: #a79bee;
		--yotpo-color-purple-50: #b4a9f1;
		--yotpo-color-purple-40: #cdc6f5;
		--yotpo-color-purple-30: #d9d4f8;
		--yotpo-color-purple-20: #e6e2fa;
		--yotpo-color-purple-10: #ece9fb;

		/* Gray */
		--yotpo-color-gray-100: #1c1d21;
		--yotpo-color-gray-90: #4e515d;
		--yotpo-color-gray-80: #696f80;
		--yotpo-color-gray-70: #82899a;
		--yotpo-color-gray-60: #adb2c0;
		--yotpo-color-gray-50: #c8ccd5;
		--yotpo-color-gray-40: #d7dae4;
		--yotpo-color-gray-30: #e4e7ee;
		--yotpo-color-gray-20: #ebedf2;
		--yotpo-color-gray-10: #f4f6f9;

		/* Others */
		--yotpo-color-white: #ffffff;

		/*
* Theme Colors
*/

		/* Brand */
		--yotpo-color-brand-100: var(--yotpo-color-blue-100);
		--yotpo-color-brand-90: var(--yotpo-color-blue-90);
		--yotpo-color-brand-80: var(--yotpo-color-blue-80);
		--yotpo-color-brand-70: var(--yotpo-color-blue-70);
		--yotpo-color-brand-60: var(--yotpo-color-blue-60);
		--yotpo-color-brand-50: var(--yotpo-color-blue-50);
		--yotpo-color-brand-40: var(--yotpo-color-blue-40);
		--yotpo-color-brand-30: var(--yotpo-color-blue-30);
		--yotpo-color-brand-20: var(--yotpo-color-blue-20);
		--yotpo-color-brand-10: var(--yotpo-color-blue-10);

		/* Success */
		--yotpo-color-success-100: var(--yotpo-color-green-100);
		--yotpo-color-success-90: var(--yotpo-color-green-90);
		--yotpo-color-success-80: var(--yotpo-color-green-80);
		--yotpo-color-success-70: var(--yotpo-color-green-70);
		--yotpo-color-success-60: var(--yotpo-color-green-60);
		--yotpo-color-success-50: var(--yotpo-color-green-50);
		--yotpo-color-success-40: var(--yotpo-color-green-40);
		--yotpo-color-success-30: var(--yotpo-color-green-30);
		--yotpo-color-success-20: var(--yotpo-color-green-20);
		--yotpo-color-success-10: var(--yotpo-color-green-10);

		/* Destructive */
		--yotpo-color-destructive-100: var(--yotpo-color-red-100);
		--yotpo-color-destructive-90: var(--yotpo-color-red-90);
		--yotpo-color-destructive-80: var(--yotpo-color-red-80);
		--yotpo-color-destructive-70: var(--yotpo-color-red-70);
		--yotpo-color-destructive-60: var(--yotpo-color-red-60);
		--yotpo-color-destructive-50: var(--yotpo-color-red-50);
		--yotpo-color-destructive-40: var(--yotpo-color-red-40);
		--yotpo-color-destructive-30: var(--yotpo-color-red-30);
		--yotpo-color-destructive-20: var(--yotpo-color-red-20);
		--yotpo-color-destructive-10: var(--yotpo-color-red-10);

		/* Warning */
		--yotpo-color-warning-100: var(--yotpo-color-yellow-100);
		--yotpo-color-warning-90: var(--yotpo-color-yellow-90);
		--yotpo-color-warning-80: var(--yotpo-color-yellow-80);
		--yotpo-color-warning-70: var(--yotpo-color-yellow-70);
		--yotpo-color-warning-60: var(--yotpo-color-yellow-60);
		--yotpo-color-warning-50: var(--yotpo-color-yellow-50);
		--yotpo-color-warning-40: var(--yotpo-color-yellow-40);
		--yotpo-color-warning-30: var(--yotpo-color-yellow-30);
		--yotpo-color-warning-20: var(--yotpo-color-yellow-20);
		--yotpo-color-warning-10: var(--yotpo-color-yellow-10);

		/* Premium */
		--yotpo-color-premium-100: var(--yotpo-color-purple-100);
		--yotpo-color-premium-90: var(--yotpo-color-purple-90);
		--yotpo-color-premium-80: var(--yotpo-color-purple-80);
		--yotpo-color-premium-70: var(--yotpo-color-purple-70);
		--yotpo-color-premium-60: var(--yotpo-color-purple-60);
		--yotpo-color-premium-50: var(--yotpo-color-purple-50);
		--yotpo-color-premium-40: var(--yotpo-color-purple-40);
		--yotpo-color-premium-30: var(--yotpo-color-purple-30);
		--yotpo-color-premium-20: var(--yotpo-color-purple-20);
		--yotpo-color-premium-10: var(--yotpo-color-purple-10);

		/* General */
		--yotpo-color-general-100: var(--yotpo-color-gray-100);
		--yotpo-color-general-90: var(--yotpo-color-gray-90);
		--yotpo-color-general-80: var(--yotpo-color-gray-80);
		--yotpo-color-general-70: var(--yotpo-color-gray-70);
		--yotpo-color-general-60: var(--yotpo-color-gray-60);
		--yotpo-color-general-50: var(--yotpo-color-gray-50);
		--yotpo-color-general-40: var(--yotpo-color-gray-40);
		--yotpo-color-general-30: var(--yotpo-color-gray-30);
		--yotpo-color-general-20: var(--yotpo-color-gray-20);
		--yotpo-color-general-10: var(--yotpo-color-gray-10);

		--yotpo-color-disabled: var(--yotpo-color-gray-50);

		/*
* Effect styles
*/

		--yotpo-shadow-10: 0px 2px 1px rgba(28, 29, 33, 0.48), 0px 0px 3px rgba(28, 29, 33, 0.12);
		--yotpo-shadow-20: 0px 2px 4px rgba(28, 29, 33, 0.12), 0px 0px 6px rgba(28, 29, 33, 0.12);
		--yotpo-shadow-30: 0px 6px 6px rgba(28, 29, 33, 0.06), 0px 0px 18px rgba(28, 29, 33, 0.12);
		--yotpo-shadow-40: 0px 8px 8px rgba(28, 29, 33, 0.12), 0px 3px 24px rgba(28, 29, 33, 0.18);
		--yotpo-focus-global: 0px 0px 0px 1px var(--yotpo-color-white), 0px 0px 0px 3px var(--yotpo-color-brand-40);

		/*
* Border radius
*/

		--yotpo-border-radius-small: 2px; /* 0.125rem */
		--yotpo-border-radius-medium: 4px; /* 0.25rem */
		--yotpo-border-radius-large: 8px; /* 0.5rem */
		--yotpo-border-radius-x-large: 12px; /* 0.75rem */
		--yotpo-border-radius-pill: 9999px;

		/*
* Spacing
*/

		--yotpo-spacing-tiny: 2px; /* 0.125rem */
		--yotpo-spacing-small: 4px; /* 0.25rem */
		--yotpo-spacing-medium: 8px; /* 0.5rem */
		--yotpo-spacing-large: 12px; /* 0.75rem */
		--yotpo-spacing-x-large: 16px; /* 1rem */
		--yotpo-spacing-xx-large: 20px; /* 1.25rem */
		--yotpo-spacing-modal: 44px; /* 2.75rem */

		/*
* Transitions
*/

		--yotpo-transition-x-slow: 1000ms;
		--yotpo-transition-slow: 500ms;
		--yotpo-transition-medium: 250ms;
		--yotpo-transition-fast: 150ms;
		--yotpo-transition-x-fast: 50ms;

		/*
* Typography
*/

		/* Fonts Declerations */
		--yotpo-font-graphie: 'Graphie';
		--yotpo-font-inter: 'Inter';

		/* Fonts Weights Declerations */
		--yotpo-font-weight-regular: normal;
		--yotpo-font-semi-weight-bold: 500;
		--yotpo-font-weight-bold: 600;

		/* Font Colors Declerations */
		--yotpo-font-color-light-primary: var(--yotpo-color-general-100);
		--yotpo-font-color-light-secondary: var(--yotpo-color-general-80);
		--yotpo-font-color-light-tertiary: var(--yotpo-color-general-70);
		--yotpo-font-color-light-disabled: var(--yotpo-color-general-50);
		--yotpo-font-color-dark-primary: var(--yotpo-color-white);
		--yotpo-font-color-dark-secondary: var(--yotpo-color-general-50);
		--yotpo-font-color-dark-tertiary: var(--yotpo-color-general-70);
		--yotpo-font-color-dark-disabled: var(--yotpo-color-general-90);

		/* Typography Font Families */
		--yotpo-font-family-heading: var(--yotpo-font-graphie);
		--yotpo-font-family-heading-h1: var(--yotpo-font-graphie);
		--yotpo-font-family-heading-h2: var(--yotpo-font-graphie);
		--yotpo-font-family-heading-h3: var(--yotpo-font-graphie);
		--yotpo-font-family-heading-h4: var(--yotpo-font-inter);
		--yotpo-font-family-text-large: var(--yotpo-font-inter);
		--yotpo-font-family-text-medium: var(--yotpo-font-inter);
		--yotpo-font-family-text-small: var(--yotpo-font-inter);

		/* Typography Font Sizes */
		--yotpo-font-size-heading: 44px; /* 2.75rem */
		--yotpo-font-size-heading-h1: 34px; /* 2.125rem */
		--yotpo-font-size-heading-h2: 25px; /* 1.563rem */
		--yotpo-font-size-heading-h3: 20px; /* 1.25rem */
		--yotpo-font-size-heading-h4: 12px; /* 0.75rem */
		--yotpo-font-size-text-large: 16px; /* 1rem */
		--yotpo-font-size-text-medium: 14px; /* 0.875rem */
		--yotpo-font-size-text-small: 12px; /* 0.75rem */

		/* Typography Font Weights */
		--yotpo-font-weight-heading: var(--yotpo-font-weight-bold);
		--yotpo-font-weight-heading-h1: var(--yotpo-font-weight-regular);
		--yotpo-font-weight-heading-h2: var(--yotpo-font-weight-bold);
		--yotpo-font-weight-heading-h3: var(--yotpo-font-weight-bold);
		--yotpo-font-weight-heading-h4: var(--yotpo-font-semi-weight-bold);
		--yotpo-font-weight-text-large-regular: var(--yotpo-font-weight-regular);
		--yotpo-font-weight-text-medium-regular: var(--yotpo-font-weight-regular);
		--yotpo-font-weight-text-small-regular: var(--yotpo-font-weight-regular);
		--yotpo-font-weight-text-large-bold: var(--yotpo-font-weight-bold);
		--yotpo-font-weight-text-medium-bold: var(--yotpo-font-weight-bold);
		--yotpo-font-weight-text-small-bold: var(--yotpo-font-weight-bold);

		/* Typography Line Heights */
		--yotpo-line-height-heading: 40px; /* 2.5rem */
		--yotpo-line-height-heading-h1: 40px; /* 2.5rem */
		--yotpo-line-height-heading-h2: 28px; /* 1.75rem */
		--yotpo-line-height-heading-h3: 24px; /* 1.5rem */
		--yotpo-line-height-heading-h4: 16px; /* 1rem */
		--yotpo-line-height-text-large: 20px; /* 1.25rem */
		--yotpo-line-height-text-medium: 20px; /* 1.25rem */
		--yotpo-line-height-text-small: 16px; /* 1rem */

		/*
* Icons
*/

		--yotpo-icon-spacing: var(--yotpo-spacing-small);
		--yotpo-icon-size: var(--yotpo-font-size-text-large);

		/*
* Forms
*/

		/* Buttons */
		--yotpo-button-border: 1px solid; /* 0.063rem */
		--yotpo-button-border-radius: var(--yotpo-border-radius-small);

		--yotpo-button-width-tiny: auto;
		--yotpo-button-width-small: 64px; /* 4rem */
		--yotpo-button-width-medium: 96px; /* 6rem */
		--yotpo-button-width-large: 96px; /* 6rem */

		--yotpo-button-height-tiny: 20px; /* 1.25rem */
		--yotpo-button-height-small: 24px; /* 1.5rem */
		--yotpo-button-height-medium: 36px; /* 2.25rem */
		--yotpo-button-height-large: 44px; /* 2.75rem */

		--yotpo-button-vertical-spacing-tiny: var(--yotpo-spacing-tiny);
		--yotpo-button-vertical-spacing-small: var(--yotpo-spacing-small);
		--yotpo-button-vertical-spacing-medium: var(--yotpo-spacing-medium);
		--yotpo-button-vertical-spacing-large: var(--yotpo-spacing-large);
		--yotpo-button-horizontal-spacing-tiny: var(--yotpo-spacing-medium);
		--yotpo-button-horizontal-spacing-small: var(--yotpo-spacing-medium);
		--yotpo-button-horizontal-spacing-medium: var(--yotpo-spacing-x-large);
		--yotpo-button-horizontal-spacing-large: var(--yotpo-spacing-x-large);
		--yotpo-button-font-size: 12px; /* 0.75rem */

		/* Inputs */
		--yotpo-input-background-color: var(--yotpo-color-white);
		--yotpo-input-background-color-hover: var(--yotpo-color-white);
		--yotpo-input-background-color-focus: var(--yotpo-color-white);
		--yotpo-input-background-color-disabled: var(--yotpo-color-general-30);

		--yotpo-input-height: 36px; /* 2.25rem */
		--yotpo-input-border-width: 1px; /* 0.0625rem */
		--yotpo-input-border-style: solid;
		--yotpo-input-border-color: var(--yotpo-color-brand-30);
		--yotpo-input-border-color-hover: var(--yotpo-color-brand-50);
		--yotpo-input-border-color-focus: var(--yotpo-color-brand-50);
		--yotpo-input-border-radius: var(--yotpo-border-radius-small);

		--yotpo-input-font-family: var(--yotpo-font-inter);
		--yotpo-input-font-weight: var(--yotpo-font-weight-regular);
		--yotpo-input-font-size: var(--yotpo-font-size-text-medium);
		--yotpo-input-line-height: var(--yotpo-line-height-text-medium);

		--yotpo-input-color: var(--yotpo-font-color-light-primary);
		--yotpo-input-color-hover: var(--yotpo-font-color-light-primary);
		--yotpo-input-color-focus: var(--yotpo-font-color-light-primary);
		--yotpo-input-color-disabled: var(--yotpo-font-color-light-disabled);

		--yotpo-input-icon-color: var(--yotpo-font-color-light-secondary);

		--yotpo-input-placeholder-color: var(--yotpo-font-color-light-tertiary);
		--yotpo-input-placeholder-color-disabled: var(--yotpo-font-color-light-disabled);

		--yotpo-input-spacing: var(--yotpo-spacing-medium);

		/* Toggles (checkboxes, radios, switches) */
		--yotpo-toggle-size: 16px; /* 1rem */
		--yotpo-two-line-toggle-size: 36px; /* 2.25rem */
		--yotpo-bigger-toggle-size: 20px; /* 1.25rem */
		--yotpo-bigger-two-line-toggle-size: 44px; /* 2.75rem */
		--yotpo-thumb-size: 14px; /* 0.875rem */

		/*
* Overlays
*/

		--yotpo-overlay-background-color: rgba(28, 29, 33, 0.7);

		/*
* Tooltips
*/

		--yotpo-tooltip-border-radius: var(--yotpo-border-radius-small);
		--yotpo-tooltip-background-color: var(--yotpo-color-brand-100);
		--yotpo-tooltip-shadow: var(--yotpo-shadow-30);
		--yotpo-tooltip-color: var(--yotpo-color-white);
		--yotpo-tooltip-color-link: var(--yotpo-color-brand-40);
		--yotpo-tooltip-font-family: var(--yotpo-font-inter);
		--yotpo-tooltip-font-weight: var(--yotpo-font-weight-regular);
		--yotpo-tooltip-font-size: var(--yotpo-font-size-text-small);
		--yotpo-tooltip-line-height: var(--yotpo-line-height-text-small);
		--yotpo-tooltip-padding: var(--yotpo-spacing-medium) var(--yotpo-spacing-large);
		--yotpo-tooltip-icon-spacing: var(--yotpo-spacing-small);
		--yotpo-tooltip-icon-font-size: var(--yotpo-font-size-text-large);
		--yotpo-tooltip-max-width: 310px; /* 19.375rem */
		--yotpo-tooltip-arrow-size: 5px;
		--yotpo-tooltip-arrow-start-end-offset: 8px;

		/*
* Z-indexes
*/

		--yotpo-z-index-drawer: 700;
		--yotpo-z-index-modal: 800;
		--yotpo-z-index-dropdown: 900;
		--yotpo-z-index-toast: 950;
		--yotpo-z-index-tooltip: 1000;
		--yotpo-z-index-sticky-page-header: 1050;
	}

	/*
* Page Header
*/

	.yotpo-sticky-content {
		position: sticky;
		top: 60px;
		z-index: 1048;
	}

	/*
* Themes Typography Decleration
*/

	.yotpo-theme-light,
	.yotpo-theme-dark {
		-webkit-font-smoothing: antialiased;
	}

	/* Size Declerations */
	.yotpo-theme-light .yotpo-text-heading,
	.yotpo-theme-dark .yotpo-text-heading {
		font-family: var(--yotpo-font-family-heading);
		font-weight: var(--yotpo-font-weight-heading);
		font-size: var(--yotpo-font-size-heading);
		line-height: var(--yotpo-line-height-heading);
	}

	.yotpo-theme-light h1,
	.yotpo-theme-dark h1 {
		font-family: var(--yotpo-font-family-heading-h1);
		font-weight: var(--yotpo-font-weight-heading-h1);
		font-size: var(--yotpo-font-size-heading-h1);
		line-height: var(--yotpo-line-height-heading-h1);
	}

	.yotpo-theme-light h2,
	.yotpo-theme-dark h2 {
		font-family: var(--yotpo-font-family-heading-h2);
		font-weight: var(--yotpo-font-weight-heading-h2);
		font-size: var(--yotpo-font-size-heading-h2);
		line-height: var(--yotpo-line-height-heading-h2);
	}

	.yotpo-theme-light h3,
	.yotpo-theme-dark h3 {
		font-family: var(--yotpo-font-family-heading-h3);
		font-weight: var(--yotpo-font-weight-heading-h3);
		font-size: var(--yotpo-font-size-heading-h3);
		line-height: var(--yotpo-line-height-heading-h3);
	}

	.yotpo-theme-light h4,
	.yotpo-theme-dark h4 {
		font-family: var(--yotpo-font-family-heading-h4);
		font-weight: var(--yotpo-font-weight-heading-h4);
		font-size: var(--yotpo-font-size-heading-h4);
		line-height: var(--yotpo-line-height-heading-h4);
	}

	.yotpo-theme-light .yotpo-text-large,
	.yotpo-theme-dark .yotpo-text-large {
		font-family: var(--yotpo-font-family-text-large);
		font-weight: var(--yotpo-font-weight-text-large-regular);
		font-size: var(--yotpo-font-size-text-large);
		line-height: var(--yotpo-line-height-text-large);
	}

	.yotpo-theme-light .yotpo-text-large.yotpo-text-bold,
	.yotpo-theme-dark .yotpo-text-large.yotpo-text-bold {
		font-weight: var(--yotpo-font-weight-text-large-bold);
	}

	.yotpo-theme-light .yotpo-text-medium,
	.yotpo-theme-dark .yotpo-text-medium {
		font-family: var(--yotpo-font-family-text-medium);
		font-weight: var(--yotpo-font-weight-text-medium-regular);
		font-size: var(--yotpo-font-size-text-medium);
		line-height: var(--yotpo-line-height-text-medium);
	}

	.yotpo-theme-light .yotpo-text-medium.yotpo-text-bold,
	.yotpo-theme-dark .yotpo-text-medium.yotpo-text-bold {
		font-weight: var(--yotpo-font-weight-text-medium-bold);
	}

	.yotpo-theme-light .yotpo-text-small,
	.yotpo-theme-dark .yotpo-text-small {
		font-family: var(--yotpo-font-family-text-small);
		font-weight: var(--yotpo-font-weight-text-small-regular);
		font-size: var(--yotpo-font-size-text-small);
		line-height: var(--yotpo-line-height-text-small);
	}

	.yotpo-theme-light .yotpo-text-small.yotpo-text-bold,
	.yotpo-theme-dark .yotpo-text-small.yotpo-text-bold {
		font-weight: var(--yotpo-font-weight-text-small-bold);
	}

	.yotpo-theme-light h1,
	.yotpo-theme-light h2,
	.yotpo-theme-light h3,
	.yotpo-theme-light h4,
	.yotpo-theme-dark h1,
	.yotpo-theme-dark h2,
	.yotpo-theme-dark h3,
	.yotpo-theme-dark h4 {
		margin: 0;
		padding: 0;
	}

	/* Color Declerations */
	.yotpo-theme-light .yotpo-text-heading,
	.yotpo-theme-light h1,
	.yotpo-theme-light h2,
	.yotpo-theme-light h3 {
		color: var(--yotpo-font-color-light-primary) !important;
	}

	.yotpo-theme-light h4 {
		color: var(--yotpo-font-color-light-secondary);
	}

	.yotpo-theme-light .yotpo-text-primary {
		color: var(--yotpo-font-color-light-primary);
	}

	.yotpo-theme-light .yotpo-text-secondary {
		color: var(--yotpo-font-color-light-secondary);
	}

	.yotpo-theme-light .yotpo-text-tertiary {
		color: var(--yotpo-font-color-light-tertiary);
	}

	.yotpo-theme-light .yotpo-text-disabled {
		color: var(--yotpo-font-color-light-disabled);
	}

	.yotpo-theme-dark .yotpo-text-heading,
	.yotpo-theme-dark h1,
	.yotpo-theme-dark h2,
	.yotpo-theme-dark h3 {
		color: var(--yotpo-font-color-dark-primary);
	}

	.yotpo-theme-dark h4 {
		color: var(--yotpo-font-color-dark-secondary);
	}

	.yotpo-theme-dark .yotpo-text-primary {
		color: var(--yotpo-font-color-dark-primary);
	}

	.yotpo-theme-dark .yotpo-text-secondary {
		color: var(--yotpo-font-color-dark-secondary);
	}

	.yotpo-theme-dark .yotpo-text-tertiary {
		color: var(--yotpo-font-color-dark-tertiary);
	}

	.yotpo-theme-dark .yotpo-text-disabled {
		color: var(--yotpo-font-color-dark-disabled);
	}

	/*
* Yotpo Scrollbar
*/
	.yotpo-scrollbar {
		scrollbar-color: var(--yotpo-color-brand-40) transparent;
	}

	.yotpo-scrollbar::-webkit-scrollbar {
		width: 18px; /* 1.125rem */
		height: 18px; /* 1.125rem */
	}

	.yotpo-scrollbar::-webkit-scrollbar-track {
		background: transparent;
	}

	.yotpo-scrollbar::-webkit-scrollbar-thumb {
		border: 5px solid rgba(0, 0, 0, 0); /* 0.313rem */
		background-clip: padding-box;
		background-color: var(--yotpo-color-brand-40);
		border-radius: 100px; /* 6.25rem */
		width: 8px; /* 0.5rem */
		outline: none;
	}

	.yotpo-scrollbar::-webkit-scrollbar-thumb:hover {
		background-color: var(--yotpo-color-brand-70);
		cursor: pointer;
	}

	/*
* Bullet List
*/

	ul.yotpo-bullet-list-checkmark,
	ul.yotpo-bullet-list-dot {
		list-style: none;
		padding: 0;
		margin: 0;
		color: var(--yotpo-color-general-100);
		font-family: var(--yotpo-font-family-text-medium);
		font-size: var(--yotpo-font-size-text-medium);
	}

	/** Sub list */
	ul ul.yotpo-bullet-list-checkmark,
	ul ul.yotpo-bullet-list-dot {
		list-style: none;
		padding: 0 0 0 20px;
	}

	ul.yotpo-bullet-list li:before {
		content: '';
		margin: 0 8px 0 0;
		padding: 0 8px;
		background-color: var(--color, #1c1d21);
		-webkit-mask-repeat: no-repeat;
		mask-repeat: no-repeat;
		-webkit-mask-position: center;
		mask-position: center;
	}

	ul.yotpo-bullet-list-checkmark li:before {
		-webkit-mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEyIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00LjY2NjYyIDcuMTE0NzVMMTAuNzk0NiAwLjk4NjA4NEwxMS43MzggMS45Mjg3NUw0LjY2NjYyIDkuMDAwMDhMMC40MjM5NSA0Ljc1NzQyTDEuMzY2NjIgMy44MTQ3NUw0LjY2NjYyIDcuMTE0NzVaIiBmaWxsPSIjMUMxRDIxIi8+Cjwvc3ZnPgo=);
		mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEyIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik00LjY2NjYyIDcuMTE0NzVMMTAuNzk0NiAwLjk4NjA4NEwxMS43MzggMS45Mjg3NUw0LjY2NjYyIDkuMDAwMDhMMC40MjM5NSA0Ljc1NzQyTDEuMzY2NjIgMy44MTQ3NUw0LjY2NjYyIDcuMTE0NzVaIiBmaWxsPSIjMUMxRDIxIi8+Cjwvc3ZnPgo=);
	}

	ul.yotpo-bullet-list-dot li:before {
		-webkit-mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSIzIiBjeT0iMyIgcj0iMyIgZmlsbD0iIzFDMUQyMSIvPgo8L3N2Zz4K);
		mask-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSI2IiB2aWV3Qm94PSIwIDAgNiA2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8Y2lyY2xlIGN4PSIzIiBjeT0iMyIgcj0iMyIgZmlsbD0iIzFDMUQyMSIvPgo8L3N2Zz4K);
	}
`;
var style = document.createElement("style");
document.head.append(style);
var linkNodeInter = document.createElement("link");
linkNodeInter.type = "text/css";
linkNodeInter.rel = "stylesheet";
linkNodeInter.href = "https://fonts.googleapis.com/css?family=Inter";
document.head.appendChild(linkNodeInter);
var linkNodeGraphie = document.createElement("link");
linkNodeGraphie.type = "text/css";
linkNodeGraphie.rel = "stylesheet";
linkNodeGraphie.href = "https://cdn-ui-assets.yotpo.com/web-fonts/graphie/style.css";
document.head.appendChild(linkNodeGraphie);

// src/styles/component.styles.ts
import { css as css3 } from "lit";

// src/styles/utility.styles.ts
import { css as css2 } from "lit";
var utility_styles_default = css2`
	${theme_styles_default}

	.yotpo-scroll-lock {
		overflow: hidden !important;
	}

	.yotpo-toast-stack {
		position: fixed;
		top: 0;
		right: 0;
		z-index: var(--yotpo-z-index-toast);
		max-width: 100%;
		max-height: 100%;
		overflow: auto;
	}

	.yotpo-toast-stack yotpo-alert {
		margin: var(--yotpo-spacing-x-large);
	}
`;

// src/styles/component.styles.ts
var component_styles_default = css3`
	:host {
		position: relative;
		box-sizing: border-box;
		-webkit-font-smoothing: antialiased;
	}

	:host *,
	:host *::before,
	:host *::after {
		box-sizing: inherit;
	}

	[hidden] {
		display: none !important;
	}
`;
var style2 = document.createElement("style");
style2.textContent = utility_styles_default.toString();
document.head.append(style2);

export {
  __spreadValues,
  __spreadProps,
  __commonJS,
  __toESM,
  __decorateClass,
  theme_styles_default,
  component_styles_default
};
